<div #chartDiv class="chart-container">
    <!-- <canvas [id]="chartId" style="width:100%; height:100%;" #chartCanvas appChart></canvas> -->
</div>